import { Factory } from '../Factory';

namespace app.services.utilities {
  export class ResourceWrapperService {
    private tokenService: app.services.authentication.TokenService;
    private configService: app.services.IConfigService;

    constructor(tokenService: app.services.authentication.TokenService, configService: app.services.IConfigService) {
      this.tokenService = tokenService;
      this.configService = configService;
    }

    // wrap given actions of a resource to send auth token with every request
    public WrapActions(resource) {
      // copy original resource
      let wrappedResource = resource;
      // Cover all actions
      let actions = ["get", "save", "query", "remove", "delete", "update", "run", "cancel", "status"];

      actions.forEach((action) => {
        // Proxy all calls to action
        let proxy_action = resource[action];
        resource[action] = (params, data, success, error) => {
          // Add our params to this resource action request
          let token_params = {
            client_id: this.configService.getClientId(),
            access_token: this.tokenService.GetAccessToken()
          };

          angular.extend(token_params, params || {});

          return proxy_action.call(this, token_params, data, success, error);
        };
      });

      // return modified copy of resource
      return wrappedResource;
    }
  }

  frontendApp.factory("ResourceWrapperService", ["TokenService", "ConfigService", Factory.Create(ResourceWrapperService)]);
}
